export default "__VITE_ASSET__JiPMXheZ__"